import { render, staticRenderFns } from "./MassReminderModal.vue?vue&type=template&id=2e93d604&scoped=true&"
import script from "./MassReminderModal.vue?vue&type=script&lang=js&"
export * from "./MassReminderModal.vue?vue&type=script&lang=js&"
import style0 from "./MassReminderModal.vue?vue&type=style&index=0&id=2e93d604&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e93d604",
  null
  
)

export default component.exports